// Purpose: Route guard — redirects unauthenticated users to /login
// Caller: App.js (wraps all /a/* routes)
// Dependencies: getUser (utils), react-router-dom Route + Redirect
// Main Functions: ProtectedRoute — renders component if authenticated, redirects otherwise
// Side Effects: Reads localStorage via getUser()

import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getUser } from 'utils'

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const user = getUser()

  return (
    <Route
      {...rest}
      render={(props) =>
        user
          ? (Component ? <Component {...props} /> : render(props))
          : <Redirect to="/login" />
      }
    />
  )
}

export default ProtectedRoute
